module.exports = __webpack_public_path__ + "img/youtubers-for-human-rights-small.3f08cbe4.jpg";